import React, { useState } from 'react'
import { Box, Button, TablePagination, useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'

import { Card, MenuButton } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import { useSnackbar } from 'hooks'

import * as service from 'service'
import helpers from 'helpers'
import { routes } from 'Routes'

const ManageUsersTable = ({
  ssoCorporateGroupId,
  ssoCorporateGroupUsers,
  totalCount,
  handleChangePage,
  handleChangeRowsPerPage,
  page,
  perPage,
  refresh,
  show,
}) => {
  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })
  const history = useHistory()

  const handleDestroy = async (ssoCorporateGroupUserId) => {
    try {
      setLoading(true)
      await service.dponet.ssoCorporateGroupUsers.destroy({
        ssoCorporateGroupId,
        ssoCorporateGroupUserId,
      })
      refresh()
      snackbar.open({
        message: 'Usuário desvinculado com sucesso!',
        variant: 'success',
      })
    } catch (error) {
      return snackbar.open({
        message: helpers.formatters.errorMessage(
          error?.response?.data?.error || 'Erro ao desvincular usuário!',
        ),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const editUser = (userId) => {
    history.push(reverse(routes.users.edit, { userId: userId }))
  }

  return (
    <Box mt={2} mb={2}>
      <Card title="Usuários vinculados">
        <PerfectScrollbar
          options={{ wheelPropagation: false, useBothWheelAxes: true }}
        >
          <Table emptyMessage="Nenhum usuário foi encontrado.">
            <TableHead>
              <TableRow>
                <TableCell width="10%">ID</TableCell>
                <TableCell width="40%">Nome</TableCell>
                <TableCell width="40%">E-mail</TableCell>
                {!show && (
                  <TableCell width="10%" align="center">
                    Ações
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {ssoCorporateGroupUsers?.map((ssoCorporateGroupUsers) => (
                <TableRow key={ssoCorporateGroupUsers?.user?.id}>
                  <TableCell>{ssoCorporateGroupUsers?.user?.id}</TableCell>
                  <TableCell>{ssoCorporateGroupUsers?.user?.name}</TableCell>
                  <TableCell>{ssoCorporateGroupUsers?.user?.email}</TableCell>
                  {!show && (
                    <TableCell align="center" disableTooltip>
                      <MenuButton>
                        <Button
                          disabled={loading}
                          onClick={() =>
                            handleDestroy(ssoCorporateGroupUsers?.id)
                          }
                        >
                          Desvincular
                        </Button>
                        <Button
                          disabled={loading}
                          onClick={() =>
                            editUser(ssoCorporateGroupUsers?.user?.id)
                          }
                        >
                          Editar
                        </Button>
                      </MenuButton>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Box px={2} display="flex" justifyContent="flex-end">
            <TablePagination
              component="div"
              count={totalCount || 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              page={page - 1}
              rowsPerPage={perPage}
              rowsPerPageOptions={[5, 10, 25, 100]}
              labelRowsPerPage={isDesktop ? 'Por página' : ''}
              nextIconButtonProps={{ size: 'small' }}
              backIconButtonProps={{ size: 'small' }}
            />
          </Box>
        </PerfectScrollbar>
      </Card>
    </Box>
  )
}

export default ManageUsersTable
